import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatEntityStatusLabel } from '#/modules/commonComponents/table/entityStatus';

const NUMERIC_ENTITY_STATUS = {
  1: 'ACTIVE',
  2: 'DRAFT',
  3: 'INACTIVE',
};

function normalizeEntityStatus(status) {
  if (typeof status === 'number') {
    return NUMERIC_ENTITY_STATUS[status] ?? String(status);
  }

  if (typeof status === 'string') {
    return status.trim().toUpperCase();
  }

  return status;
}

/**
 * 主檔 entity `status` badge（非單據 DocumentStatusBadge）。
 * 色票走 statusBadgeTheme：ACTIVE=綠、INACTIVE=紅、DRAFT=olive；兼相容數字 1／3／2。
 */
const EntityStatusBadge = ({ status, label, className }) => {
  const normalized = normalizeEntityStatus(status);

  if (!normalized) {
    return <span className={cn('text-sm text-gray-500', className)}>-</span>;
  }

  return (
    <StatusBadge
      status={normalized}
      label={label ?? formatEntityStatusLabel(normalized)}
      size="sm"
      className={cn('shrink-0', className)}
    />
  );
};

EntityStatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.node,
  className: PropTypes.string,
};

export default EntityStatusBadge;
